<!-- ============ Horizontal (modal admin) ============ -->
<div class="custom-stepper" *ngIf="!vertical">
    <div class="steps-row">
        <ng-container *ngFor="let paso of pasos; let i = index; let last = last">
            <div class="step"
                 [ngClass]="{
                     'step--done': estadoPaso(i) === 'done',
                     'step--current': estadoPaso(i) === 'current',
                     'step--rejected': paso.rejected && estadoPaso(i) !== 'pending'
                 }">
                <div class="step__circle">
                    <span *ngIf="estadoPaso(i) === 'done'" class="material-icons">check</span>
                    <span *ngIf="estadoPaso(i) !== 'done' && paso.icon" class="material-icons">{{ paso.icon }}</span>
                    <span *ngIf="estadoPaso(i) !== 'done' && !paso.icon">{{ i + 1 }}</span>
                </div>
                <div class="step__label">{{ paso.label }}</div>
            </div>

            <div class="connector"
                 *ngIf="!last"
                 [ngClass]="{ 'connector--active': estadoPaso(i + 1) !== 'pending' }"></div>
        </ng-container>
    </div>

</div>

<!-- ============ Vertical (solicitud) ============ -->
<div class="custom-stepper-v" *ngIf="vertical" [ngClass]="{ 'custom-stepper-v--sin-progreso': sinProgreso }">
    <div class="vstep"
         *ngFor="let paso of pasos; let i = index; let last = last"
         [ngClass]="{
             'vstep--done': estadoPaso(i) === 'done',
             'vstep--current': estadoPaso(i) === 'current',
             'vstep--pending': estadoPaso(i) === 'pending',
             'vstep--rejected': paso.rejected && estadoPaso(i) !== 'pending'
         }">
        <div class="vstep__rail">
            <div class="vstep__dot">
                <span *ngIf="estadoPaso(i) === 'done'" class="material-icons">check</span>
                <span *ngIf="estadoPaso(i) !== 'done' && paso.icon" class="material-icons">{{ paso.icon }}</span>
                <span *ngIf="estadoPaso(i) !== 'done' && !paso.icon">{{ i + 1 }}</span>
            </div>
            <div class="vstep__line" *ngIf="!last"></div>
        </div>

        <div class="vstep__content">
            <div class="vstep__label">{{ paso.label }}</div>
            <div class="vstep__desc" *ngIf="paso.descripcion" [innerHTML]="paso.descripcion"></div>
        </div>
    </div>

</div>
